import * as firebase from 'firebase';
import {successCotiza,successRegresar,returnReinicio} from '../reducers/todo-reducer';
import {properties} from '../properties/properties';
import axios from 'axios';

export default  {

	cotizacion(values){
		return new Promise((resolve,reject)=>{
          
            console.log(values);
            var riesgo = "";
           
            if (values.fuma === "S") {
                riesgo = `${values.genero}FE`;
            } else {
                riesgo =`${values.genero}NFE`; 
            }

            firebase.database().ref(`cotizador_retiro/tarifas/${values.edad_actual}`).once("value", snapshot => {
                const data = snapshot.val();
                var tarifa = 0;
                values.edadretiro = parseInt(values.edadretiro);
                if(data){
                    if(values.edadretiro >= 55 && values.edadretiro < 60)
                    {
                        tarifa = data.retiro55;
                    }
                    else if(values.edadretiro >= 60 && values.edadretiro < 65)
                    {
                        tarifa = data.retiro60;
                    }
                    else if(values.edadretiro >= 65 && values.edadretiro < 70)
                    {
                        tarifa = data.retiro65;
                    }
                    else if(values.edadretiro === 70)
                    {
                        tarifa = data.retiro70;
                    }
                }
                else{
                    tarifa = 0;
                }

                var ahorro_mensual = 0;

                if(values.ahorro_mensual){
                    if(values.ahorro_mensual.trim() !== "" || values.ahorro_mensual > 0){
                        ahorro_mensual = values.ahorro_mensual;
                    }
                }
                var peticion = {
                    datos : {
                        ahorroMensual:ahorro_mensual,
                        aniosPension:values.anios_pension,
                        edadActual:values.edad_actual,
                        edadRetiro:values.edadretiro,
                        fuma:values.fuma,
                        genero:values.genero,
                        ingresoMensual:values.ingreso,
                        porcentajeSalario:values.porSueldo
                    },
                    tarifa : tarifa,
                    riesgo: riesgo
                };

               

                var url = properties().COTIZA_RETIRO;
                var accion = "Cotizo"

                if(values.recotiza){
                    url = properties().RECOTIZA_RETIRO;
                    accion = "Recotizo";
                    peticion.nprima = values.ahorro_mensual;
                }

                console.log(peticion);

                        new Promise((resolve,reject)=>{
                            console.log(url);
                            axios({
                                method: 'post',
                                url: url,
                                data: peticion,
                                headers: {
                                    'Content-Type': 'application/json',
                                    'x-api-key': properties().API_KEY
                                }
                            }).then((response) => {
                                if(response){
                                    console.log("DIEGO", response.data);
                                    var resultado = response.data;
                                    resolve(resultado);
                                }else{
                                    resolve(false);
                                }
                            }).catch((error) => {
                                resolve(false);
                            });	
                
                        }).then((res)=>{
                            debugger;
                            var opcionMedida = { };
                            var aportaciones ={};

                            if(values.recotiza){

                                console.log(res);
                                if(res.nprima < values.ahorro_mensual || res.nprima > values.ahorro_mensual){
                                    opcionMedida.texto = "Se ajustó el ahorro mensual debido a que la protección mínima es de $400,000 pesos.";
                                }

                                opcionMedida.prima = res.nprima;
                                opcionMedida.monto = res.mmensual;
                                opcionMedida.sumaAsegurada = res.incrementosa;

                                

                                res.aportacion = {};

                                res.aportacion.aportacion = values.aportaciones.porcentaje;
                                res.aportacion.aportacionMensual = values.aportaciones.mensual;

                                aportaciones = values.aportaciones;
                            }else{

                                if(res.aportacion.aportacion > 100){
                                resolve({exito:false,
                                    texto:"Debes ahorrar más de lo que ganas para retirarte a la edad que deseas. Favor de intentar con otra combinación."});
                                
                                }
                                else{
                                    if(res.hasOwnProperty('nprima'))
                                    {
                                    
                                        opcionMedida.prima = res.nprima;
                                        opcionMedida.monto = res.mmensual;
                                        opcionMedida.sumaAsegurada = res.incrementosa;
    
                                        aportaciones.porcentaje = Math.round(res.aportacion.aportacion);
                                        aportaciones.mensual = Math.round(res.aportacion.aportacionMensual)
                                    
                                        if(res.nprima < values.ahorro_mensual || res.nprima > values.ahorro_mensual){
                                            opcionMedida.texto = "Se ajustó el ahorro mensual debido a que la protección mínima es de $400,000 pesos.";
                                        }
                                    }
                                    else{
                                        res.nprima = 0;
                                        res.incrementosa = 0;
                                        aportaciones.porcentaje = Math.round(res.aportacion.aportacion);
                                        aportaciones.mensual = Math.round(res.aportacion.aportacionMensual)
                                    
                                    }
                                }
                            }
                            const fecha = new Date();
                            const json = {nombre: values.nombre,
                                        apellidos: values.apellidos,
                                        correo: values.correo,
                                        tipo_telefono: values.tTelefono,
                                        telefono: values.telefono,
                                        accion: accion,
                                        edad: values.edad_actual,
                                        edad_retiro: values.edadretiro,
                                        genero: values.genero,
                                        fumador: values.fuma,
                                        sueldo_deseado: values.porSueldo,
                                        ahorro: res.aportacion.aportacion,
                                        prima_mensual: res.nprima,
                                        suma_asegurada: res.incrementosa,
                                        fecha: fecha.toString(),
                                        timestamp :fecha.getTime()
                            };
                            firebase.database().ref("cotizador_retiro/cotizaciones").push().set(json);


                            resolve({
                                exito:true,
                                data:{
                                    values : values,
                                    res : res,
                                    opcionMedida:opcionMedida,
                                    aportaciones:aportaciones
                                }
                            })
                        });

            });
            
		}).then(successCotiza);
    },
    regresar(values){
        return new Promise((resolve,reject)=>{
            resolve(values);
        }).then(successRegresar);
    },
    reinicio(){
        return new Promise((resolve,reject)=>{
            resolve(true);
        }).then(returnReinicio);
    }
}



// WEBPACK FOOTER //
// ./src/apis/todo-api.js